import React from 'react';

import type { ThemeOption } from '@/app/ThemeContext';
import type { TabOption } from '@/components/chariot-ui';
import { getRepoInfo } from '@/sections/poe/components/RepoInfo';
import type {
  MainTabKey,
  POEContent,
  SectionContent,
} from '@/sections/poe/types/poe.types';
import { formatKey } from '@/sections/poe/utils/formatKey';
import { mapToMainTab } from '@/sections/poe/utils/mapToMainTab';

export const processGenericDataSource = (
  poeData: POEContent,
  sections: Record<string, SectionContent>,
  tempTabs: Record<MainTabKey, TabOption[]>,
  theme: ThemeOption,
  mainTabKeys: MainTabKey[],
  copyContents?: Record<string, string>
) => {
  if (typeof poeData === 'object' && poeData !== null) {
    Object.entries(poeData).forEach(([key, value]) => {
      if (key === 'repository_url' && typeof value === 'string') {
        const repoInfo = getRepoInfo(value, theme);
        if (repoInfo) {
          sections[repoInfo.tab] = repoInfo.content;
          if (mainTabKeys.includes('ATTRIBUTES')) {
            tempTabs['ATTRIBUTES'].push({
              label: repoInfo.tab,
              value: repoInfo.tab.toLowerCase(),
            });
          }
        }
      } else {
        const formattedKey = formatKey(key);
        sections[key] =
          typeof value === 'string' ? value : JSON.stringify(value, null, 2);

        const mainTab = mapToMainTab(formattedKey, mainTabKeys);
        tempTabs[mainTab].push({
          label: formattedKey,
          value: key,
        });
      }
    });
  }
  // Always add Raw Data section for unknown sources, even if poeData is empty or a string
  if (
    mainTabKeys.includes('INFORMATION') &&
    poeData &&
    (typeof poeData === 'string' || Object.keys(poeData).length > 0)
  ) {
    const rawData =
      typeof poeData === 'string' ? poeData : JSON.stringify(poeData, null, 2);
    // Store plain text version for copying
    if (copyContents && rawData) {
      copyContents['data'] = rawData.trim();
    }
    sections['data'] = (
      <pre className="text-chariot-text-primary m-0 max-h-96 overflow-auto border-0 bg-transparent p-0 font-mono text-sm wrap-anywhere whitespace-pre-wrap">
        {rawData?.trim()}
      </pre>
    );
    tempTabs['INFORMATION'].push({ label: 'Data', value: 'data' });
  }
};
